import { useParams } from "react-router-dom"
import { useGetGameQuery } from "quiz/api/games.endpoints"

export function useGame() {
  const { gameId } = useParams<{ gameId: string }>()
  return useGetGameQuery(gameId!).data
}
